import React from "react";

import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import { Button } from "@mapmycustomers/ui";

import Card from "./Card";
import StageCard from "./StageCard";
import styles from "./StageList.module.scss";

interface Props {
  disabled?: boolean;
  loading?: boolean;
  onNextClick: () => void;
  onPreviousClick: () => void;
  selectedIndex: number;
  stages: Stage[];
}

const StageList: React.FC<Props> = ({
  disabled,
  loading,
  onNextClick,
  onPreviousClick,
  selectedIndex,
  stages,
}) => {
  const stageCards: StageCard[] = stages.map((stage, index) => ({
    ...stage,
    leftIndex: index < selectedIndex ? selectedIndex - index - 1 : undefined,
    rightIndex: index > selectedIndex ? index - selectedIndex - 1 : undefined,
    selected: index === selectedIndex,
  }));

  return (
    <div className={styles.container}>
      <div className={styles.gradient} />
      <div className={styles.pointer} />
      {stageCards.map((stageCard, index, stageCards) => (
        <Card
          {...stageCard}
          index={index}
          key={stageCard.id}
          name=""
          totalCards={stageCards.length}
        />
      ))}
      {/* Selected card is rendered twice. In the list and here VVV */}
      <Card
        {...stages[selectedIndex]}
        index={selectedIndex}
        loading={loading}
        selected
        totalCards={stageCards.length}
      />
      <Button
        className={cn(styles.prev, { [styles.hidden]: selectedIndex <= 0 })}
        disabled={disabled}
        icon={<FontAwesomeIcon icon={faChevronLeft} />}
        iconOnly
        onClick={onPreviousClick}
      />
      <Button
        className={cn(styles.next, { [styles.hidden]: selectedIndex >= stages.length - 1 })}
        disabled={disabled}
        icon={<FontAwesomeIcon icon={faChevronRight} />}
        iconOnly
        onClick={onNextClick}
      />
    </div>
  );
};

export default StageList;
